import { useState, useCallback } from 'react';

const VALIDATION_REGEXES = {
    name: /^[A-Za-z\u00C0-\u02AF\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u2D00-\u2DFF\uA640-\uA69F\u1C80-\u1C88' -]+$/,
    gsm: /^\+[0-9\s]{3,20}$/,
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
};

export const useProjectForm = () => {
    const [formData, setFormData] = useState({
        customerLastName: "",
        customerFirstName: "",
        customerGsmNumber: "+32",
        customerEmail: "",
        customerAddressStreetAndHouse: "",
        customerAddressBusStation: "",
        customerAddressCity: "",
        customerPrivacyAccepted: false,
        customerPrivacyMarketing: false,
        customerIsAxaCustomer: undefined,
        customerDescription: "",
    });

    const [errors, setErrors] = useState({
        lastName: false,
        firstName: false,
        gsm: false,
        email: false,
        privacy: false,
        address: false,
        isAxaCustomer: false,
    });

    const validateField = useCallback((field, value) => {
        switch (field) {
            case 'lastName':
            case 'firstName':
                return VALIDATION_REGEXES.name.test(value);
            case 'gsm':
                return VALIDATION_REGEXES.gsm.test(value);
            case 'email':
                return VALIDATION_REGEXES.email.test(value);
            case 'address':
                return Boolean(value);
            case 'privacy':
                return Boolean(value);
            case 'isAxaCustomer':
                return value !== undefined;
            default:
                return true;
        }
    }, []);

    const updateField = useCallback((field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    }, []);

    const updateFieldWithValidation = useCallback((field, value, errorField) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [errorField]: !validateField(errorField, value) }));
    }, [validateField]);

    const validateAll = useCallback(() => {
        const newErrors = {
            lastName: !validateField('lastName', formData.customerLastName),
            firstName: !validateField('firstName', formData.customerFirstName),
            gsm: !validateField('gsm', formData.customerGsmNumber),
            email: !validateField('email', formData.customerEmail),
            privacy: !validateField('privacy', formData.customerPrivacyAccepted),
            address: !validateField('address', formData.customerAddressStreetAndHouse),
            isAxaCustomer: !validateField('isAxaCustomer', formData.customerIsAxaCustomer),
        };
        setErrors(newErrors);
        return !Object.values(newErrors).some(error => error);
    }, [formData, validateField]);

    const resetForm = useCallback(() => {
        setFormData({
            customerLastName: "",
            customerFirstName: "",
            customerGsmNumber: "+32",
            customerEmail: "",
            customerAddressStreetAndHouse: "",
            customerAddressBusStation: "",
            customerAddressCity: "",
            customerPrivacyAccepted: false,
            customerPrivacyMarketing: false,
            customerIsAxaCustomer: undefined,
            customerDescription: "",
        });
        setErrors({
            lastName: false,
            firstName: false,
            gsm: false,
            email: false,
            privacy: false,
            address: false,
            isAxaCustomer: false,
        });
    }, []);

    return {
        formData,
        errors,
        updateField,
        updateFieldWithValidation,
        validateAll,
        resetForm,
        setFormData,
        setErrors
    };
};
